/**
 * @fileoverview General utils.
 */
var $ = require('jquery');
// ES module default export requires .default when using require()
var scrollMonitorModule = require('scrollmonitor');
var scrollMonitor = scrollMonitorModule.default || scrollMonitorModule;

var now = Date.now || function() {
    return new Date().getTime();
};

function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;

  var later = function() {
    var last = now() - timestamp;
    if (last < wait) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  return function() {
    context = this;
    args = arguments;
    timestamp = now();
    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * Watches for an element to come into scroll view.
 * @param {Element|jQueryElement} el
 * @param {Function} callback
 */
function scrollWatcher(el, threshold, callback) {
  // Convert jQuery object to DOM element if needed
  var domEl = el.jquery ? el[0] : el;
  
  var watcher = scrollMonitor.create(domEl, threshold);
  
  // Force scrollMonitor to recalculate - sometimes DOM isn't fully settled
  scrollMonitor.update();
  watcher.recalculateLocation();
  
  watcher.enterViewport(function() {
    callback('enter', watcher);
  });
  watcher.exitViewport(function() {
    callback('exit', watcher);
  });
}

function resizeIframes() {
  $('article > iframe, article > p > iframe, article > .inertia-oembed iframe').each(function () {
    var el = $(this);

    var ratio = parseInt(el.attr('width'), 10) / parseInt(el.attr('height'), 10);

    var width = el.width();
    var height = (1 / ratio) * width;

    el.attr({
      width: width,
      height: height
    });
  })
}

function isUARobot() {
  return /bot|crawler|spider|crawling|LinkedInBot/i.test(navigator.userAgent);
}

module.exports = {
  debounce: debounce,
  resizeIframes: resizeIframes,
  scrollWatcher: scrollWatcher,
  isUARobot: isUARobot
};
